import { render, staticRenderFns } from "./conformidade.vue?vue&type=template&id=208dbe37&scoped=true"
import script from "./conformidade.vue?vue&type=script&lang=js"
export * from "./conformidade.vue?vue&type=script&lang=js"
import style0 from "./conformidade.vue?vue&type=style&index=0&id=208dbe37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208dbe37",
  null
  
)

export default component.exports